import type { EvaluationContext } from '@openfeature/web-sdk';

export type FeatureFlagUser = {
  id?: string | number | null;
  username?: string | null;
  orgs_id?: string | number | null;
  orgs_title?: string | null;
  roles?: {
    title?: string | null;
  } | null;
} | null;

export const ANONYMOUS_FEATURE_FLAG_CONTEXT: EvaluationContext = {
  targetingKey: 'anonymous',
  isAnonymous: true,
};

function normalizeValue(value?: string | number | null) {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  return String(value);
}

export function buildFeatureFlagContext(userData?: FeatureFlagUser) {
  if (!userData) {
    return ANONYMOUS_FEATURE_FLAG_CONTEXT;
  }

  const tenantId = normalizeValue(userData.orgs_id);
  const userId = normalizeValue(userData.id);
  const username = userData.username || undefined;
  const tenantName = userData.orgs_title || undefined;
  const role = userData.roles?.title || undefined;

  return {
    targetingKey: tenantId || 'anonymous',
    isAnonymous: !tenantId,
    ...(tenantId ? { tenantId, tenant_id: tenantId, orgs_id: tenantId } : {}),
    ...(tenantName
      ? { tenantName, tenant_name: tenantName, orgs_name: tenantName }
      : {}),
    ...(userId ? { userId, user_id: userId } : {}),
    ...(username ? { username } : {}),
    ...(role ? { role } : {}),
  };
}
